import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

import {MemberPostService} from "../../service/member-post/member-post.service";

import {MemberPost} from "../../service/member-post/member-post";

@Component({
  selector: 'app-member-detail',
  templateUrl: 'member-detail.component.html',
  styleUrls: ['member-detail.component.scss'],
  providers: [MemberPostService]
})
export class SpaceMemberDetailComponent{
  post: MemberPost;
  id: number;
  innerHeight: number;

  constructor(private postService: MemberPostService,
              private route: ActivatedRoute)
  {
    this.innerHeight = window.innerHeight - (window.innerWidth > 768 ? 105 : 70);

    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;
      if (this.id) {
        this.postService.getPost(this.id).subscribe(post => {
          this.post = post;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/space/member-detail/member-detail.component.ts